import { Link } from "react-router-dom";

export const LogoSymbol = ({ size = 36, className = "" }) => (
  <svg width={size} height={size} viewBox="0 0 48 48" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="zvGold" x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#F1DA9A" /><stop offset=".5" stopColor="#D4AF63" /><stop offset="1" stopColor="#A9863F" /></linearGradient>
    </defs>
    <circle cx="24" cy="10.5" r="4.6" fill="url(#zvGold)" />
    <path d="M22.6 41C13 35.5 7.5 27 8.6 16.5c6.6 3.4 12.4 10.6 14 24.5z" fill="url(#zvGold)" />
    <path d="M25.4 41c9.6-5.5 15.1-14 14-24.5-6.6 3.4-12.4 10.6-14 24.5z" fill="url(#zvGold)" />
  </svg>
);

export const LogoMark = ({ size = 36 }) => (
  <span className="inline-grid place-items-center rounded-[28%] bg-[#003B2D] ring-1 ring-[#D4AF63]/40 shrink-0" style={{ width: size, height: size }}>
    <LogoSymbol size={size * 0.74} />
  </span>
);

export const Wordmark = ({ light, size = "text-[26px]", tag = true }) => (
  <span className="flex flex-col leading-none">
    <span className={`font-display ${size} font-semibold tracking-[0.08em] ${light ? "text-[#FAF8F2]" : "text-[#003B2D]"}`}>
      ZUNVEL<sup className="text-[9px] text-[#D4AF63] ml-0.5 tracking-normal align-super">™</sup>
    </span>
    {tag && <span className={`text-[8.5px] font-bold tracking-[0.42em] mt-1.5 ${light ? "text-[#E6C77B]" : "text-[#85662A]"}`}>CARE. WORK. GROW.</span>}
  </span>
);

export const Logo = ({ light = false, to = "/" }) => (
  <Link to={to} className="flex items-center gap-2 shrink-0" data-testid="brand-logo-link" aria-label="Zunvel home">
    <LogoSymbol size={40} />
    <Wordmark light={light} />
  </Link>
);

export const LogoStacked = ({ light = false }) => (
  <div className="flex flex-col items-center gap-2" data-testid="brand-logo-stacked">
    <LogoSymbol size={64} />
    <Wordmark light={light} size="text-4xl" />
  </div>
);
